export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_00.cd8b436f.jpg";